import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const isAuthenticated = () => {
  const token = Cookies.get('fytn_token');
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && Date.now() >= decoded.exp * 1000) {
      // Token expired, clear cookies
      Cookies.remove('fytn_token');
      Cookies.remove('fytn_user');
      return false;
    }
    return true;
  } catch (e) {
    // Invalid token, clear cookies
    Cookies.remove('fytn_token');
    Cookies.remove('fytn_user');
    return false;
  }
};

const PrivateRoute = ({ element }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return element;
};

export default PrivateRoute;
